module.exports = __webpack_public_path__ + "static/the-way-of-kings-00bf41a618496b630eea6ea0b8d57633.jpg";